import { store } from '../../core/store.js'

export const TIERS = Object.freeze({ L0: 'l0', L1: 'l1', L2: 'l2' })

function readUrlTier() {
  const tier = new URLSearchParams(window.location.search).get('tier')
  return Object.values(TIERS).includes(tier) ? tier : null
}

export function getUsageCount() {
  return Number(store.getState('creation.studioUseCount') || 0)
}

export function getTier() {
  return store.getState('creation.studioTier') || readUrlTier() || TIERS.L0
}

export function setTier(tier, { replace = false } = {}) {
  if (!Object.values(TIERS).includes(tier)) return getTier()
  store.setState('creation.studioTier', tier)
  const url = new URL(window.location.href)
  url.searchParams.set('tier', tier)
  window.history[replace ? 'replaceState' : 'pushState']({}, '', url)
  return tier
}

export function recordStudioUse() {
  const next = getUsageCount() + 1
  store.setState('creation.studioUseCount', next)
  return next
}

export function hasSourceImage() {
  return Boolean(store.getState('sourceImage')?.url)
}

export function resolveAutomaticTier() {
  if (getTier() === TIERS.L2) return TIERS.L2
  return hasSourceImage() ? TIERS.L1 : TIERS.L0
}

export function syncTierFromContext() {
  const current = getTier()
  if (current === TIERS.L2) return current
  return setTier(resolveAutomaticTier(), { replace: true })
}
